import React, { useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";
import "./QRCode.scss";

const QRCode = () => {
  const qrRef = useRef(null);

  useEffect(() => {
    const qrCode = new QRCodeStyling({
      width: 200,
      height: 200,
      margin: 5,
      data: window.location.href,
      dotsOptions: {
        // This sets both the outer marker and inner marker style to "rounded"
        type: "rounded",
      },
      // Optional: if you ever decide to add a logo or need additional styling options
      imageOptions: {
        crossOrigin: "anonymous",
      },
    });

    if (qrRef.current) {
      qrCode.append(qrRef.current);
    }
  }, []);

  return <div className="qr-code-container" ref={qrRef} />;
};

export default QRCode;
